import React from 'react'

export const CancelBtn = ({ type, customClassName, customStyles, onClick, submitClicked, title = "Cancel" }) => {
    return (
        <button
            type={type}
            disabled={submitClicked}
            onClick={onClick}
            className={`btn btn-default-outline ${customClassName}`}
            style={{ cursor: 'pointer', ...customStyles }}
        >
            {title}
        </button>
    )
}
